import * as zoid from "@krakenjs/zoid/dist/zoid.frameworks.js";

export const DesignAreasEditor = zoid.create({
  tag: "design-areas-editor",
  url: `${SERVER_URL}/design-areas-editor`,
  dimensions: {
    width: "100%",
    height: "100%",
  },
});
